<template>
  <div>
    <datatable
      :is_createable="false"
      :show_load_ghana_flags_button="true"
      :show_sort_ghana_flags_button="false"
      :show_delete="false"
      :show_header_filter="false"
      title="Positions"
      @thFilter="thFilter"
      @edit_hover="editHover"
      @edit_leave="editLeave"
      @edit_click="editClick"
      @internal_notes="clickedInternalNotes"
      @related_positions_manager="showConnectedPositionManager"
      @duplicate_position="duplicatePosition"
      @ai_work_position="aiWorkPosition"
      @screening_questions="openScreeningQuestions"
      :fields="fields"
      :filters="filters"
      :sorters="sorters"
      :counters="counters"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-positions',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      filters_helper,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'company_name',
          component_data_path: 'company',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Company'
          }
        },
        {
          name: 'position_title',
          value: 'title',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Position'
          }
        },
        {
          name: 'status',
          value: 'status',
          component: 'PositionStatus'
        },
        {
          name: 'message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/positions/',
            headers: 'admin_headers',
            resource_type: 'Position'
          }
        },
        {
          name: 'skills',
          value: 'positions_skills',
          component: 'DisplaySkills'
        },
        {
          name: 'offers',
          value: 'offers',
          component: 'GhanaFlag',
          additional_data: {
            resource_type: 'Position'
          },
          props: {
            sent_applicants: true
          }
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'company_id',
          value: 'company.id'
        }
      ],
      filters: [
        {
          type: 'input',
          designator: 'company_name'
        },
        {
          type: 'multi_term_input',
          designator: 'position_title',
          placeholder: 'Search by position title'
        },
        {
          type: 'single',
          designator: 'statuses',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'standby',
              value: 'standby'
            },
            {
              text: 'blocked',
              value: 'blocked'
            },
            {
              text: 'expired',
              value: 'expired'
            },
            {
              text: 'editing',
              value: 'editing'
            },
            {
              text: 'fulfilled',
              value: 'fulfilled'
            },
            {
              text: 'deleted',
              value: 'deleted'
            },
            {
              text: 'test',
              value: 'test'
            }
          ]
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        },
        {
          type: 'single',
          designator: 'is_hot',
          options: [
            {
              text: 'true',
              value: true
            },
            {
              text: 'false',
              value: false
            }
          ]
        },
        {
          type: 'modal',
          designator: 'tagged_skills',
          options: this.dropdownFeaturedSkills
        },
        {
          type: 'modal',
          designator: 'office_size',
          options: []
        },
        {
          type: 'modal',
          designator: 'seniority',
          options: []
        },
        {
          type: 'modal',
          subType: 'min-max-experience',
          designator: 'min_max_experience',
          splitter: '|'
        },
        {
          type: 'modal',
          subType: 'min-max-seniority',
          designator: 'min_max_seniority',
          splitter: '|'
        }
      ],
      sorters: [
        {
          designator: 'id',
          value: '-id'
        },
        {
          designator: 'created_at',
          value: '-created_at'
        },
        {
          designator: 'active_at',
          value: '-active_at'
        }
      ],
      counters: [],
      data: [],
      operations: [
        { component: 'IsHot' },
        {
          component: 'CompletenessIndicator',
          additional_data: { resource_type: 'Position', api_path: '/positions/' }
        },
        {
          component: 'Preview',
          additional_data: { resource_type: 'Position' }
        },
        { name: 'internal_notes', icon: '/note.png' },
        { name: 'related_positions_manager', icon: '/group.svg' },
        {
          component: 'AlertButton',
          additional_data: { resource_type: 'Position' }
        },
        { name: 'duplicate_position', icon: '/duplicate.svg' },
        { name: 'ai_work_position', title: 'AI Work' },
        { name: 'screening_questions', icon: '/screening_questions.svg', title: 'שאלות למועמד בצ\'אט' }
      ],
      th_filters: [],
      working_th_searches: [],
      is_sorting_by_ghana_flags: false
    }
  },
  created: function () {
    this.init()
    this.fetchAll()
    this.fetchAllSkills()
  },
  computed: {
    ...mapGetters('modals', ['findModal']),
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('skills', ['dropdownFeaturedSkills'])
  },
  watch: {
    dropdownAdmins (newValue) {
      this.watchTreeShaking(newValue, 'owner')
    },
    dropdownFeaturedSkills (newValue) {
      this.watchTreeShaking(newValue, 'tagged_skills')
    }
  },
  methods: {
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getPositions()
    },
    watchTreeShaking (newValue, designator) {
      this.filters.forEach(filter => {
        if (filter.designator == designator) {
          filter.options = newValue
        }
      })
    },
    init () {
      this.getPositions()
      this.getQuestionsFilters()
    },
    getPositions () {
      const dataSeniority = this.$route.query['min_max_seniority'] ? this.$route.query['min_max_seniority'].split('|') : []

      const hasTextSearchTerms = (this.$route.query.position_title && this.$route.query.position_title !== '')

      const page = this.$route.query.page || 1

      let params = {
        page: page,
        sort: this.$route.query.sort || '-id',
        ...this.filters_helper.getServerCallFilters(this.filters),
        ...this.th_filters,
        min_seniority: dataSeniority[0],
        max_seniority: dataSeniority[1]
      }

      if (this.$route.query.is_sort_ghana_flags) {
        params.per = 400
      } else if (!hasTextSearchTerms) {
        params.per = 100
      } else { params.per = 999999 }

      this.$network_utils
        .getAllPositions(params)
        .then(response => {
          response = Array.isArray(response) ? response : [response]
          this.data = response
        })
      this.$network_utils
        .getAllPositions({
          sort: this.$route.query.sort || 'active_at',
          count_only: true,
          is_hot: true,
          statuses: 'active'
        })
        .then(response => {
          this.counters.push({
            name: 'hot-positions',
            label: 'hot positions',
            value: response
          })
        })
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'office_size,seniority', current_resource_id: 1, current_type: 'Position' }).then(response => {
        const relevantQuestions = response.filter(question =>
          question.options && question.options.length > 0
        )

        relevantQuestions.forEach(question => {
          this.addQuestionOptionsToFilters(question)
        })
        this.$forceUpdate()
      })
    },
    addQuestionOptionsToFilters (question) {
      let filter_options = question.options.map(option => {
        return { text: option.text, value: option.id.toString() }
      })

      this.filters.forEach((filter, index) => {
        if (filter.designator == question.designator) {
          this.$set(this.filters[index], 'options', filter_options)
        }
      })
    },
    duplicatePosition (data) {
      this.create({
        designator: 'duplicate-position-form-modal',
        component_name: 'DuplicatePosition',
        data,
        modal_title: 'Duplicate Position - ' + data.title
      })
    },
    aiWorkPosition (data) {
      if (!confirm('תן ל-AI לעבוד על המשרה "' + data.title + '"?')) return
      this.$network_utils
        .aiWorkPosition({ position_id: data.id })
        .then(() => alert('הסוכן הופעל על המשרה'))
        .catch(err => alert('שגיאה בהפעלת הסוכן: ' + (err && err.message ? err.message : err)))
    },
    showConnectedPositionManager (data) {
      this.create({ designator: 'connected-position-manager-modal', component_name: 'ConnectedPositionManager', position: data, modal_title: data.title + ' - Connected Position Manager', is_center_modal: true, modal_width: 1400 })
    },
    // Opens the position modal scrolled to the chatbot screening-questions editor.
    openScreeningQuestions (data) {
      this.create({ designator: 'position-screening-modal', component_name: 'ModalPosition', modal_width: 1500, data: data, focus: 'screening', modal_title: 'Position: ' + data.title + ', Company: ' + data.company.name })
    },
    editHover (data) {
      this.create({ designator: 'position-info-modal', component_name: 'ModalPosition', modal_width: 1500, data: data, modal_title: 'Position: ' + data.title + ', Company: ' + data.company.name })
    },
    editLeave () {
      let position_info_modal = this.findModal({ type: 'designator', value: 'position-info-modal' })
      this.remove(position_info_modal)
    },
    editClick (data) {
      this.create({ designator: 'position-form-modal', component_name: 'PositionForm', data, modal_title: data.title })
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Position', resource_id: data.id, modal_title: data.title + ' הערות פנימיות' })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapActions('skills', ['fetchAllSkills']),
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
